import { render } from "./PageAnalyticsForCrossCuttingTasks.vue?vue&type=template&id=63d02058&scoped=true"
import script from "./PageAnalyticsForCrossCuttingTasks.vue?vue&type=script&lang=js"
export * from "./PageAnalyticsForCrossCuttingTasks.vue?vue&type=script&lang=js"

import "./PageAnalyticsForCrossCuttingTasks.vue?vue&type=style&index=0&id=63d02058&scoped=true&lang=scss"
import "./PageAnalyticsForCrossCuttingTasks.vue?vue&type=style&index=1&id=63d02058&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d02058"]])

export default __exports__